import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '../assets/img/close.png'


const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = {
  id: "meta",
  ref: "meta"
}
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = { class: "loading-progress" }
const _hoisted_5 = { class: "loading-text" }
const _hoisted_6 = {
  key: 1,
  class: "home-iframe"
}
const _hoisted_7 = {
  key: 2,
  class: "home-html"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1gqtnq8mk18qakm0e5c19t0vc39.png",
  alt: ""
}, null, -1)
const _hoisted_9 = {
  key: 3,
  class: "windows"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Link = _resolveComponent("Link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("canvas", _hoisted_2, null, 512),
    (_ctx.pg < 100)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", {
              style: `width: ${ _ctx.pg }%`
            }, null, 4)
          ]),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.pg >= 90 ? '已完成加载，正在启动' : '正在加载...') + "(" + _toDisplayString(_ctx.pg) + "%)", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", {
            class: "home-layer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = ''))
          }),
          (_ctx.show.type === 'link')
            ? (_openBlock(), _createBlock("iframe", {
                key: 0,
                src: _ctx.show.link
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (_ctx.show.type === 'video')
            ? (_openBlock(), _createBlock("video", {
                key: 1,
                src: _ctx.show.link,
                ref: "video",
                id: "video",
                poster: _ctx.show.poster,
                controls: "",
                autoplay: "",
                loop: "",
                "x5-playsinline": "",
                playsinline: "",
                controlslist: "nodownload"
              }, null, 8, ["src", "poster"]))
            : _createCommentVNode("", true),
          _createVNode("img", {
            class: "home-close-btn",
            src: _imports_0,
            alt: "关闭",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = ''))
          }),
          (_ctx.show.type === 'html')
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_Link)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isTip)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "tip",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isTip = false))
        }, [
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    (_ctx.isWin)
      ? (_openBlock(), _createBlock("div", _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.isBlur)
      ? (_openBlock(), _createBlock("div", {
          key: 4,
          class: "blur",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
          onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args)))
        }, "游戏已暂停运行，点击回到游戏", 32))
      : _createCommentVNode("", true)
  ]))
}